import { render } from "./ApproveRejectPopUp.vue?vue&type=template&id=20ec9714&scoped=true"
import script from "./ApproveRejectPopUp.js?vue&type=script&lang=js"
export * from "./ApproveRejectPopUp.js?vue&type=script&lang=js"

import "./ApproveRejectPopUp.vue?vue&type=style&index=0&id=20ec9714&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ec9714"]])

export default __exports__